function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


function hideFFScrollBars(e){
    // console.log('hideFFScrollBars', e.target.parentNode)
    var scrollbarHeight = 20; // Currently 17, may change with updates

    if(/firefox/i.test(navigator.userAgent)){
        // We only need to appy to desktop. Firefox for mobile uses
        // a different rendering engine (WebKit)
        if (window.innerWidth > 575){
            e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px'
        }
    }
}


function refreshGlider(e){
    hideFFScrollBars(e)

    var mainText = document.querySelector('.MainText');
    var gliderTracks = document.querySelectorAll('.glider-track');


    if(mainText && window.innerWidth -100 > mainText.offsetWidth){
        var margin = Math.round(window.innerWidth - mainText.offsetWidth)/2 -30;

        for (var i = 0; i < gliderTracks.length; ++i) {
            gliderTracks[i].style.marginLeft = margin + 'px'
        }

    }else{
        for (var i = 0; i < gliderTracks.length; ++i) {
            gliderTracks[i].style.marginLeft = '0'
        }
    }

}


document.addEventListener('glider-loaded', refreshGlider);
document.addEventListener('glider-refresh', refreshGlider);

export function initGlider() {

    console.log(('init glider'));

    var gliders = document.querySelectorAll('.Glider');


    for (var i = 0; i < gliders.length; ++i) {


        new Glider(gliders[i], {
            slidesToShow: 1,
            // exactWidth: true,
            // slidesToShow: 'auto',
            slidesToScroll: 1,
            draggable: true,
            // how much to scroll with each mouse delta
            dragVelocity: 2,
            // exactWidth: true,
            // resizeLock: true,
            scrollLock: true,
            scrollLockDelay: 150,
            easing: function (x, t, b, c, d) {
                return c*(t/=d)*t + b;
            },
            responsive: [
                {
                    breakpoint: 820,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                    }
                },{
                    breakpoint: 1020,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1,
                    }
                },
            ]
        });


        // setTimeout(()=>{
        //     console.log('resize ' + i)
        //     // initGlider();
        //     glidersInitialized[i] .refresh(true);
        //     // $(window).resize()
        // }, 2000)


    }







    /*
    new Glider(document.querySelector('.Glider'), {

        // `auto` allows automatic responsive
        // width calculations
        slidesToShow: 'auto',
        slidesToScroll: 'auto',

        // should have been named `itemMinWidth`
        // slides grow to fit the container viewport
        // ignored unless `slidesToShow` is set to `auto`
        itemWidth: undefined,

        // if true, slides wont be resized to fit viewport
        // requires `itemWidth` to be set
        // * this may cause fractional slides
        exactWidth: false,

        // speed aggravator - higher is slower
        duration: .5,

        // dot container element or selector
        dots: 'CSS Selector',

        // arrow container elements or selector
        arrows: {
            prev: 'CSS Selector',
            // may also pass element directly
            next: document.querySelector('CSS Selector')
        },

        // allow mouse dragging
        draggable: false,
        // how much to scroll with each mouse delta
        dragVelocity: 3.3,

        // use any custom easing function
        // compatible with most easing plugins
        easing: function (x, t, b, c, d) {
            return c*(t/=d)*t + b;
        },

        // event control
        scrollPropagate: false,
        eventPropagate: true,

        // Force centering slide after scroll event
        scrollLock: false,
        // how long to wait after scroll event before locking
        // if too low, it might interrupt normal scrolling
        scrollLockDelay: 150,

        // Force centering slide after resize event
        resizeLock: true,

        // Glider.js breakpoints are mobile-first
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });

     */



}




    setTimeout(function () {
        console.log('resize')



        var resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);

    }, 1000)




